import { render, staticRenderFns } from "./RoomPreviewCard.vue?vue&type=template&id=ada90ec0&"
import script from "./RoomPreviewCard.vue?vue&type=script&lang=ts&"
export * from "./RoomPreviewCard.vue?vue&type=script&lang=ts&"
import style0 from "./RoomPreviewCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports